import type { CSSProperties, SVGProps } from "react";

import { css, cx } from "simplydo/react/styled";

import type { UISize } from "../utils/UIContext";
import { ICON_SIZE_PX } from "../utils/iconSize";

export type BrandIconProps = {
  /** Matches Lucide `Icon` sizes, or a raw pixel number. */
  size?: UISize | number;
  color?: string;
  className?: string;
  style?: CSSProperties;
} & Omit<SVGProps<SVGSVGElement>, "color" | "children">;

const BrandIconStyle = css`
  display: inline-block;
  vertical-align: middle;
  alignment-baseline: middle;
  stroke: none;
`;

export const BrandIconComponent = ({
  size = "medium",
  color = "currentColor",
  className,
  style,
  path,
  ...rest
}: BrandIconProps & { path: string }) => {
  const px = typeof size === "number" ? size : ICON_SIZE_PX[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={px}
      height={px}
      focusable="false"
      style={{ fill: color, ...style }}
      className={cx("brand-icon", BrandIconStyle, className)}
      {...rest}
    >
      <path d={path} />
    </svg>
  );
};
